import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientsService } from '@app/shared/services/clients.service';

@Component({
  selector: 'app-add-client',
  templateUrl: './add-client.component.html',
  styleUrls: ['./add-client.component.css']
})
export class AddClientComponent implements OnInit {
  addClientForm: FormGroup;
  isUpdateMode: boolean = false;
  clientId: string | null = null;

  constructor(
    private formBuilder: FormBuilder,
    private clientService: ClientsService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.addClientForm = this.formBuilder.group({
      clientName: ['', [Validators.required, Validators.minLength(3)]],
      contactNo: [''],
      email: ['', [Validators.required, Validators.email]]
    });
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.clientId = params['id'];
      if (this.clientId) {
        this.isUpdateMode = true;
        this.updateClient(this.clientId);
      }
    });
  }

  updateClient(id: string) {
    this.clientService.getClientById(id).subscribe(
      (res: any) => this.addClientForm.patchValue(res),
      (err: any) => console.error(err)
    );
  }

  addClient() {
    if (this.addClientForm.valid) {
      const clientData = this.addClientForm.value;

      const request = this.isUpdateMode 
        ? this.clientService.updateClient(this.clientId!, clientData) 
        : this.clientService.addClient(clientData);

      request.subscribe(
        () => {
          console.log(`${this.isUpdateMode ? 'Client updated' : 'Client added'} successfully`);
          this.addClientForm.reset();
          this.router.navigate(['/clientList']);
        },
        (err: any) => console.error('Failed to process client:', err)
      );
    }
  }
}

